<template>

    <div id="entry">
        <div class="common-header container clearfix">
            <div class="logo"></div>
            <div title="" class="title">{{ mecoName }}机考模拟系统</div>
        </div>
        <div class="main" v-loading="loading">

            <div id="realMockExam">
                <div class="stepContainer step3">
                    <div class="step_con">
                        <h1 class="coursename">{{ result.paper_name }}</h1>
                        <p>1.本试卷答题共用时 {{ result.times }}。</p>
                        <p>2.自动判卷只能判断客观题。</p>
                        <el-button @click="reBack" class="reBack" type="primary"
                            icon="el-icon-arrow-left">返回列表</el-button>
                    </div>
                    <div class="bgModel">
                        <div class="result-title">
                            <h4>答题情况</h4>
                        </div>
                        <div class="result-abs clearfix">
                            <div class="abs-hd fl">
                                <p class="abs-tit">你的得分</p>
                                <div class="abs-fraction"><strong class="ng-binding">{{ result.score ? result.score :
                                    '0.0' }}</strong>分</div>
                                <div class="abs-text ng-scope ng-binding">
                                    共{{ result.total }}道题，你答对：{{ result.right }}道
                                </div>
                            </div>
                            <div class="abs-bd fr">
                                <div class="box">
                                    <div class="box_title" v-if="result.judge > 0">判断题（点序号查看解析）</div>
                                    <div class="box_question">
                                        <li @click="nextQuestion(item)"
                                            :class="jsonData[item - 1].user_answer_right == 1 ? 'right' : 'error'"
                                            v-for="item in result.judge" :key="item">{{ item }}</li>
                                    </div>
                                    <div class="box_title" v-if="result.radio > 0">单向选择题（点序号查看解析）</div>
                                    <div class="box_question">
                                        <li @click="nextQuestion(result.judge + item)"
                                            :class="jsonData[result.judge + item - 1].user_answer_right == 1 ? 'right' : 'error'"
                                            v-for="item in result.radio" :key="item">{{ result.judge + item }}</li>
                                    </div>
                                    <div class="box_title" v-if="result.checkbox > 0">多项选择题（点序号查看解析）</div>
                                    <div class="box_question">
                                        <li @click="nextQuestion(result.judge + result.radio + item)"
                                            :class="jsonData[result.judge + result.radio + item - 1].user_answer_right == 1 ? 'right' : 'error'"
                                            v-for="item in result.checkbox" :key="item">{{ result.judge + result.radio +
                                                item }}
                                        </li>
                                    </div>
                                    <div class="box_title" v-if="result.indefinite > 0">不定项【共享题干】（点序号查看解析）</div>
                                    <div class="box_question">
                                        <li @click="nextQuestion(result.judge + result.radio + result.checkbox + item)"
                                            :class="jsonData[result.judge + result.checkbox + result.radio + item - 1].user_answer_right == 1 ? 'right' : 'error'"
                                            v-for="item in result.indefinite" :key="item">{{ result.judge + result.radio
                                                + result.checkbox + item }}
                                        </li>
                                    </div>
                                    <div class="box_title" v-if="result.compatibility > 0">配伍题【共享选项】（点序号查看解析）</div>
                                    <div class="box_question">
                                        <li @click="nextQuestion(result.judge + result.radio + result.checkbox + result.indefinite + item)"
                                            :class="jsonData[result.judge + result.checkbox + result.radio + result.checkbox + item - 1].user_answer_right == 1 ? 'right' : 'error'"
                                            v-for="item in result.compatibility" :key="item">{{ result.judge + result.radio
                                                + result.checkbox + result.indefinite + item }}
                                        </li>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="result-title">
                            <h4>历史记录</h4>
                        </div>
                        <div class="result-abs clearfix">
                            <div class="abs-bd fr" style="width: 97%;">
                                <table border="0" cellspacing="0" cellpadding="0" class="abs-table">
                                    <tbody>
                                        <tr>
                                            <th></th>
                                            <th class="ng-scope">考试记录</th>
                                            <th>总分</th>
                                            <th>用时</th>
                                            <th>考试时间</th>
                                            <th>详情</th>
                                        </tr>
                                        <tr class="ng-scope" v-for="(item, index) in history" :key="index">
                                            <td align="center" class="ng-binding">{{ index + 1 }}</td>
                                            <td align="center" class="ng-scope ng-binding"> {{ item.paper_name }} </td>
                                            <td align="center" class="ng-binding">{{ item.score }}</td>
                                            <td align="center" class="ng-binding">{{ item.times }}</td>
                                            <td align="center" class="ng-binding">{{ item.created_at }}</td>
                                            <td align="center" class="ng-binding btns" @click="ngDetail(item)">详情</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
        <div class="footer"></div>

        <div class="window" v-if="showDesc">
            <div class="hs"></div>
            <div class="windowContent">
                <p class="tishi">试题解析</p>
                <div class="delete">
                    <div class="infoTest">
                        <div class="title" v-html="questionData.title"></div>
                        <div class="li" v-for="(item, index) in questionData.select_list">
                            <div class="li_sort">{{ item.key }}</div>
                            <div class="li_desc" v-html="item.value"></div>
                        </div>
                        <div class="li_answer">
                            <div class="right_answer"> 正确答案：{{ questionData.answer }} </div>
                            <div class="my_answer"> 我的答案：{{ questionData.user_answer }}</div>
                        </div>
                        <div class="li_ntitle">参考解析：</div>
                        <div class="li_src" v-html="questionData.content"></div>
                    </div>
                    <div class="t_center">
                        <a v-if="nums < 100" href="javascript:" class="btn" @click="nextQuestion(idx - 1)">上一题</a>
                        <a v-if="nums < 100" href="javascript:" class="btn" @click="nextQuestion(idx + 1)">下一题</a>
                        <a v-if="nums != 0" href="javascript:" class="btn" @click="showDesc = false">返回列表</a>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: true,
            showDesc: false,
            questionData: [],
            meauActive: "",
            idx: 1,
            percentage: 0,
            nums: 10,
            pc: 0,
            pc_id: 0,
            column_id: 0,
            subject_id: 0,
            mecoSeat: sessionStorage.getItem("access-mecoSeat"),
            mecoName: sessionStorage.getItem("access-mecoName"),
            mecoTitle: sessionStorage.getItem("access-mecoTitle"),
            urls: "//www.chinaacc.com/mnxt/jjskcgz.htm",
            result: [],
            jsonData: [],
            history: [],
        };
    },
    mounted: function () {
        var that = this;
        var query = that.$route.query;
        if (query.pc_id) {
            that.pc_id = query.pc_id;
            that.column_id = query.column_id;
            this.getList();
        }
    },
    methods: {

        nextQuestion(idx) {
            console.log(idx);
            if (idx == 0 || idx == this.jsonData.length + 1) {
                alert("已经是最后一题了");
                return false;
            }
            this.idx = idx;
            this.questionData = this.jsonData[idx - 1];
            this.showDesc = true;
        },

        getList() {
            let that = this;
            let formData = {};
            this.loading = true;
            formData.pc_id = that.pc_id;
            formData.column_id = that.column_id;
            that.axios.post("/getPaperResult", formData).then((res) => {
                if (res) {
                    that.result = res.data;
                    that.column_id = res.data.column_id;
                    that.subject_id = res.data.subject_id;
                    that.jsonData = res.data.question;
                    that.history = res.data.history;
                    that.loading = false;
                }
            });
        },

        ngDetail(item) {
            this.pc_id = item.id;
            this.column_id = item.column_id;
            this.getList();
        },

        reBack() {
            console.log(this.column_id);
            console.log(this.subject_id);
            if (this.column_id == 75) {
                this.$router.push({
                    path: "/guide/index",
                    query: {
                        column_id: this.column_id,
                        subject_id: this.subject_id
                    },
                });
            } else if (this.column_id == 61) {
                this.$router.push({
                    path: "/meco/yiwei/index",
                    query: {
                        column_id: this.column_id,
                        subject_id: this.subject_id
                    },
                });
            } else {
                this.$router.push({
                    path: "/meco/index",
                    query: {
                        column_id: this.column_id,
                    },
                });
            }
        },

    },
};
</script>

<style>
@import "../../../public/css/meco.css";

.hs,
.window {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 9999999
}

.hs .hs,
.window .hs {
    background: #666;
    z-index: 999;
    filter: Alpha(opacity=50);
    opacity: .5
}

.hs .windowContent,
.window .windowContent {
    width: 500px;
    border: 2px solid #1d7ecc;
    background-color: #fff;
    z-index: 999;
    left: 50%;
    margin-left: -250px;
    top: 50%;
    margin-top: -140px;
    position: absolute;
    height: 280px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box
}

.hs .windowContent .tishi,
.window .windowContent .tishi {
    height: 46px;
    line-height: 46px;
    border-bottom: 1px solid #1d7ecc;
    background-color: #1d7ecc;
    padding-left: 20px;
    font-size: 16px;
    margin-top: 0;
    color: #fff
}

.hs .windowContent .infoTest,
.window .windowContent .infoTest {
    font-size: 16px;
    color: #f97217;
    text-align: left;
    min-height: 100px;
}

.hs .windowContent .infoTest span,
.window .windowContent .infoTest span {
    display: inline-block;
    margin-top: 14px;
    margin-left: 70px
}

.hs .windowContent .infoTest.icon,
.window .windowContent .infoTest.icon {
    background: url(data:image/png;base64,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) no-repeat;
    padding-left: 100px;
    width: 380px;
    color: #e8661b;
    margin: 40px auto;
    line-height: 30px;
}

.hs .windowContent .t_center,
.window .windowContent .t_center {
    text-align: center;
    position: absolute;
    bottom: 15px;
    left: 0;
    right: 0;
}

.hs .windowContent .t_center .btn,
.window .windowContent .t_center .btn {
    border-radius: 3px;
    width: 120px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    color: #fff;
    background-color: #1d7ecc;
    font-size: 14px;
    display: inline-block;
    padding: 0;
}

.hs .windowContent .t_center .btn+.btn,
.window .windowContent .t_center .btn+.btn {
    margin-left: 20px;
    background: #e7661d
}

#realMockExam .step3 .step_con {
    border: none;
    border-bottom: 1px solid #daefff;
}

.infoTest {
    padding: 20px 30px 20px 30px;
    margin-bottom: 10px;
}

.result-abs .btns {
    color: #28a71d;
    cursor: pointer;
}

.infoTest .title {
    line-height: 30px;
    font-size: 17px;
    font-weight: bold;
    color: #666666;
}

.infoTest .li {
    display: flex;
    flex-direction: row;
    line-height: 28px;
    color: #777777;
    padding-left: 17px;
}

.infoTest .li_ntitle {
    line-height: 27px;
    font-weight: bold;
    color: #666;
    margin: 5px 0;
}


.infoTest .li_answer {
    line-height: 32px;
    margin: 5px 0;
    display: flex;
    flex-direction: row;
    font-weight: bold;
}

.infoTest .li_src {
    line-height: 22px;
    overflow: auto;
    min-height: 190px;
    max-height: 220px;
    font-size: 14px;
}

.infoTest .right_answer {
    margin-right: 20px;
}

#entry .main {
    padding-top: 0 !important;
}

.step_con p {
    color: #999;
    padding: 0 30px 10px 30px;
    font-size: 12px;
}

.bgModel {
    border-radius: 6px;
}

.bgModel {
    background: #fff;
    border-radius: 6px;
}

.result-title {
    margin: 0 30px;
    height: 56px;
    line-height: 56px;
    padding: 0;
}

.result-title h4 {
    font-size: 16px;
    color: #07bdc7;
}

.clearfix:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
    overflow: hidden;
}

.fl {
    float: left;
    display: inline;
}

.fr {
    float: right;
    display: inline;
}

.result-abs {
    padding-bottom: 10px;
}

.result-abs .abs-hd {
    width: 244px;
    height: 160px;
    margin-left: 44px;
    background: url(../../../public/images/result-absNew.png) no-repeat center top;
    text-align: center
}

.result-abs .abs-hd .abs-tit {
    font-size: 16px;
    color: #fd7400;
    margin-top: 26px
}

.result-abs .abs-hd .abs-fraction {
    overflow: hidden;
    font-size: 28px;
    color: #fd7400;
    font-weight: 700
}

.result-abs .abs-hd .abs-fraction strong {
    font-size: 32px;
    line-height: 50px;
    display: inline-block
}

.result-abs .abs-hd .abs-text {
    line-height: 32px;
    font-weight: 700;
    color: #fff;
    margin-top: 5px;
    font-size: 14px;
}

.result-abs .abs-hd .abs-tip {
    font-size: 14px;
    color: #555;
    margin-top: 26px
}

.result-abs .abs-bd {
    width: 608px;
}

.result-abs .abs-bd.wd-910 {
    width: 910px
}

.abs-table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #eaeaea
}

.abs-table td,
.abs-table th {
    line-height: 24px;
    padding: 4px;
    font-size: 12px;
    border: 1px solid #efefef
}

.abs-table td.scoring {
    background-color: #e8f8f9;
    color: #07bdc7
}

.abs-table th {
    font-weight: 400;
    color: #666;
    font-size: 14px;
    background: #f8f8f8
}

.abs-table .ash {
    color: #999
}

.result-topicLists {
    border-top: 1px solid #eaeaea
}

.answerType .abs-table {
    color: #666
}

.answerType .abs-table td:first-child {
    font-weight: 700;
    color: #333
}

.box {
    display: flex;
    flex-direction: column;
    height: 400px;
    overflow: scroll;
}

.box .box_title {
    height: 32px;
    line-height: 32px;
    font-weight: bold;
    font-size: 14px;
}

.box .box_question {
    display: flex;
    flex-wrap: wrap;
    margin: 10px 0 10px 0;
}

.box .box_question li {
    list-style-type: none;
    width: 32px;
    height: 32px;
    border: 1px solid #ccc;
    line-height: 32px;
    text-align: center;
    margin-right: 10px;
    margin-bottom: 10px;
    border-radius: 3px;
    font-size: 12px;
    cursor: pointer;
}

.box .box_question li.error {
    background-color: #e45858;
    color: #ffffff;
    border: none;
}

.box .box_question li.right {
    background-color: #28a71d;
    color: #ffffff;
    border: none;
}

.reBack {
    position: absolute;
    bottom: 20px;
    right: 20px;
}

.window .windowContent {
    height: 650px;
    width: 750px;
    left: 43%;
    top: 30%;
}
</style>